// Centralized muscle group mapping and utilities
export const MUSCLE_GROUP_MAP = {
  chest: ["chest"],
  back: ["lats", "middle back", "lower back"],
  shoulders: ["shoulders"],
  biceps: ["biceps"],
  triceps: ["triceps"],
  legs: ["quadriceps", "hamstrings", "calves"],
  glutes: ["glutes"],
  core: ["abdominals"],
};

export const MUSCLE_GROUPS = ['chest', 'back', 'shoulders', 'biceps', 'triceps', 'legs', 'core', 'glutes'];

/**
 * Maps exercise muscle groups to our simplified categories
 * @param {Array} primaryMuscles - Primary muscle groups from exercise
 * @param {Array} secondaryMuscles - Secondary muscle groups from exercise
 * @returns {Array} Array of mapped muscle group categories
 */
export const getMappedMuscleGroups = (primaryMuscles, secondaryMuscles) => {
  const matches = new Set();
  const allMuscles = [...(primaryMuscles || []), ...(secondaryMuscles || [])];
  
  for (const [group, aliases] of Object.entries(MUSCLE_GROUP_MAP)) {
    if (allMuscles.some(m => aliases.includes(m.toLowerCase()))) {
      matches.add(group);
    }
  }
  
  return Array.from(matches);
};
